<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">服务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">提交白名单</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">提交白名单</div>
      </div>
      <div class="panel-body">
        <div class="alert-master z-margin-bottom-20-precent">
          <p>1：白名单仅用于云服务器用户提交，其他用户无需申请。</p>
          <p>2：白名单提交的域名必须是备案域名，未备案的域名无法提交，备案被注销后白名单中也会同步删除。</p>
          <p>3：未备案域名请使用免备案服务，在<router-link to="/freeBeian" class="z-color-a">免备案服务</router-link>中提交。</p>
        </div>
        <el-form :model="bmdForm"  ref="bmdForm" label-width="180px" class="bmd-form" status-icon >
          <el-form-item label="提交域名：" prop="domain">
            <el-input v-model="bmdForm.domain"></el-input>
            <!--<el-input v-model="bmdForm.number" placeholder="自动获取备案号" :disabled="true" class="z-margin-left-5-precent"></el-input>-->
          </el-form-item>
          <el-form-item label="对应的IP：" prop="domain">
            <el-input v-model="bmdForm.ip"></el-input>
          </el-form-item>
          <el-form-item label="">
            <p class="z-font-size-12">*提交后系统将自动给出CNAME解析地址，按照此地址解析域名即可</p>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
    <!--blackpink-->
    <div v-if="dialogShadow" class="dialogShadow"></div>
    <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
      <dd class="dialogTitle z-font-size-16">
        <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
        <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
      </dd>
      <dd class="dialogContent z-color-666 z-font-size-15 ">
        <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
        <span class="z-font-size-15" >域名尚未备案，无法提交！</span>
        <br>
        <router-link to="/freeBeian" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 116px">请到免备案服务中提交</router-link>
      </dd>
      <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
        <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
        <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
      </div>
    </dl>
  </div>
</template>
<script>
  import VpsService from 'business/VpsService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogShadow:false,
        dialogLoading:false,
        bmdForm:{
          domain:'',
          ip:'',
          number:''
        }
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {

    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async submit() {
        let data = 'cmd=bmd_add'+
          '&domainname='+ this.bmdForm.domain +
          '&vpsip='+ this.bmdForm.ip
        this.dialogLoading = true
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.$router.push('/fuwu5')
          }})
        }else {
          this.dialogLoading = false
          if(vueData.msg === '域名尚未备案，无法提交！'){
            this.dialogShadow = true
          }else {
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }
      },
      clickBtn() {
        this.dialogShadow = false
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }

  .bmd-form .el-input {
    width: 340px;
  }
  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fuwu/fuwu4.vue